<p-dialog
    [(visible)]="visible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closeOnEscape]="true"
    [dismissableMask]="true"
    [style]="{width: '90vw', maxWidth: '1200px'}"
    styleClass="p-fluid comunica-contributo-dialog"
    [showHeader]="false"
    (onHide)="hide()">

    <div class="dialog-container">
        <div class="dialog-header">
            <div class="header-content">
                <i class="pi pi-euro header-icon"></i>
                <h2>Rendicontazione intervento</h2>
                 <div *ngIf="intervento?.scheda?.vecchioCodiceUmvs" class="code-badge legacy-code" style="background-color: #f0f0f0; padding: 0.25rem 0.5rem; border-radius: 4px; margin-left: 1rem; border-left: 3px solid #8f5cb7;">
                   <span class="code-value" style="font-weight: bold; color: #8B4513; " pTooltip="VECCHIO CODICE UMVS" tooltipPosition="top">{{ intervento?.scheda?.vecchioCodiceUmvs }}</span>
                  </div>
                  <div class="code-badge" style="background-color: #f0f0f0; padding: 0.25rem 0.5rem; border-radius: 4px; margin-left: 1rem; border-left: 3px solid #4285F4;">
                    <span class="code-value" style="font-weight: bold; color: #3a6e75;" pTooltip="NUOVO CODICE" tooltipPosition="top">{{ intervento?.scheda?.codice }}</span>
                  </div>

            </div>
            <button
                pButton
                pRipple
                icon="pi pi-times"
                class="p-button-rounded p-button-text close-btn"
                (click)="hide()">
            </button>
        </div>

        <div class="dialog-content">
            <!-- Bottone per eliminare tutti i file -->
            <!-- <div class="actions-header" style="display: flex; justify-content: flex-end; margin-bottom: 1rem;">

            </div>
 -->
            <!-- Spinner per la verifica dei file -->
            <div *ngIf="isCheckingFiles" class="loading-files-overlay" style="display: flex; justify-content: center; align-items: center; padding: 2rem; background-color: #f8f9fa; border-radius: 8px; margin-bottom: 1rem;">
                <div style="text-align: center;">
                    <ng-lottie [options]="options" width="100px" height="100px"></ng-lottie>
                    <p style="margin-top: 1rem; color: #6c757d; font-size: 14px;">Verifica presenza file in corso...</p>
                </div>
            </div>

            <!-- Tabella rendicontazioni (mostrata solo quando non si stanno verificando i file) -->
            <p-table *ngIf="!isCheckingFiles" [value]="rendicontazioni" styleClass="p-datatable-sm" [scrollable]="true" scrollHeight="400px">
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 5%">Azioni</th>
                        <th style="width: 10%">Data</th>
                        <th style="width: 10%; text-align: center">Tipo</th>
                        <th style="width: 15%; text-align: center">Importo</th>
                        <th style="width: 10%; text-align: center" class="text-center">Allegati</th>
                        <th style="width: 30%" class="determina-cell">Determina UMVS</th>

                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rendicontazione>
                    <tr>
                      <td class="text-center" style="width: 10px;">
                        <button
                          pButton type="button" style="color:rgb(39, 128, 15)"
                          icon="pi pi-ellipsis-v" class="p-button-rounded p-button-text small-icon"
                          (click)="openCaricaAzioni($event,rendicontazione)"
                          >
                        </button>
                      </td>
                        <td>{{ rendicontazione.creata | date:'dd/MM/yyyy' }}</td>
                        <td pTooltip="{{ rendicontazione.note }}" tooltipPosition="top" style="text-align: center">
                            <span class="badge" [ngClass]="{
                                'badge-acconto': rendicontazione.tipo.descrizione === 'ACCONTO',
                                'badge-saldo': rendicontazione.tipo.descrizione === 'SALDO'
                            }">
                                {{ rendicontazione.tipo.descrizione }}
                            </span>
                        </td>
                        <td style="text-align: center; vertical-align: middle;">
                            <div class="importo-container" style="display: flex; align-items: center; justify-content: center;">
                                <span class="importo-valore">{{ rendicontazione.importo | currency:'EUR':'':'1.2-2':'it-IT' }}</span>
                                <i class="pi pi-euro importo-icon"></i>
                            </div>
                        </td>

                        <td style="text-align: center;">
                                <div class="document-buttons" style="display: flex; align-items: center; justify-content: center; gap: 0.5rem;">
                                  <button
                                  pButton
                                  type="button"
                                  icon="pi pi-eye"
                                  class="p-button-rounded p-button-text p-button-sm p-button-info"
                                  (click)="mostraListaFile(rendicontazione)"
                                  [pTooltip]="'Visualizza i file di questa rendicontazione'"
                                  tooltipPosition="top"
                                  [disabled]="!rendicontazione.hasFiles">
                              </button>
                                <button
                                    pButton
                                    type="button"
                                    icon="pi pi-download"
                                    class="p-button-rounded p-button-text p-button-sm p-button-info"
                                    (click)="scaricaDocumentiRendicontazione(rendicontazione)"
                                    [pTooltip]="'Scarica tutti i file della rendicontazione'"
                                    tooltipPosition="top"
                                    [disabled]="!rendicontazione.hasFiles">
                                </button>

                                <!-- NUOVO: Pulsante Upload -->
                                <button
                                    pButton
                                    type="button"
                                    icon="pi pi-upload"
                                    class="p-button-rounded p-button-text p-button-sm p-button-success"
                                    (click)="caricaNuoviDocumenti(rendicontazione)"
                                    [pTooltip]="'Carica nuovi allegati'"
                                    tooltipPosition="top">
                                </button>
                                <!-- NUOVO: Pulsante Visualizza File -->


                                <!-- NUOVO: Pulsante Elimina File -->
                                <button
                                    pButton
                                    type="button"
                                    icon="pi pi-trash"
                                    class="p-button-rounded p-button-text p-button-sm p-button-danger"
                                    (click)="mostraConfermaEliminazioneFile(rendicontazione)"
                                    [pTooltip]="'Elimina tutti gli allegati di questa rendicontazione'"
                                    tooltipPosition="top"
                                    [disabled]="!rendicontazione.hasFiles">
                                </button>


                            </div>
                        </td>
                        <td class="determina-cell">
                          <div *ngIf="rendicontazione.numeroDetermina && hasDeterminaFiles(rendicontazione)"
                               class="determina-clickable"
                               (click)="scaricaDocumentiDetermina(rendicontazione)"
                               [pTooltip]="'Clicca per scaricare i documenti della determina'"
                               tooltipPosition="top">
                            <div class="determina-main">
                              <i class="pi pi-book determina-icon"></i>
                              <span class="determina-number">{{ rendicontazione.numeroDetermina }}</span>
                              <div *ngIf="rendicontazione.dataDetermina" class="determina-date-badge">
                                <i class="pi pi-calendar determina-date-icon"></i>
                                <span>{{ rendicontazione.dataDetermina | date:'dd/MM/yyyy' }}</span>
                              </div>
                            </div>
                          </div>
                          <span *ngIf="!rendicontazione.numeroDetermina || !hasDeterminaFiles(rendicontazione)" class="no-determina">-</span>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="footer">
                    <tr class="footer-row">
                        <td [attr.colspan]=" 3" class="footer-label">Totale Rendicontato</td>
                        <td style="text-align: center;">
                            <div class="importo-totale">
                                <span class="importo-valore">{{ getTotaleRendicontato() | currency:'EUR':'':'1.2-2':'it-IT' }} </span>
                                <i class="pi pi-euro importo-icon"></i>
                            </div>
                        </td>
                        <td colspan="2"></td>
                    </tr>
                </ng-template>
            </p-table>

            <!-- Messaggio quando non ci sono rendicontazioni -->
            <div *ngIf="!isCheckingFiles && (!rendicontazioni || rendicontazioni.length === 0)" class="no-rendicontazioni" style="text-align: center; padding: 2rem; color: #6c757d;">
                <i class="pi pi-info-circle" style="font-size: 2rem; margin-bottom: 1rem;"></i>
                <p>Nessuna rendicontazione trovata per questo intervento.</p>
            </div>

            <!-- Menu azioni -->

        </div>
    </div>

    <div *ngIf="isDownloading" class="loading-overlay" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(255,255,255,0.9); display: flex; justify-content: center; align-items: center; z-index: 1000;">
        <ng-lottie [options]="options" width="300px" height="300px"></ng-lottie>
    </div>
</p-dialog>
<p-tieredMenu #azioniMenuTiered [model]="menuAzioniItems" [popup]="true"></p-tieredMenu>
<app-comunica-determina *ngIf="selectedRendicontazione" [rendicontazione]="selectedRendicontazione" (comunicaDetermina)="onComunicaDetermina($event)"></app-comunica-determina>
<app-modifica-rendicontazione
    *ngIf="selectedRendicontazione"
    [rendicontazione]="selectedRendicontazione"
    [intervento]="intervento"
    (rendicontazioneModificata)="onRendicontazioneModificata($event)">
</app-modifica-rendicontazione>

<app-carica-documenti-rendicontazione
    #caricaDocumentiComponent
    [rendicontazione]="selectedRendicontazione"
    [intervento]="intervento"
    (documentiCaricati)="onDocumentiCaricati()">
</app-carica-documenti-rendicontazione>

<p-toast position="top-right"></p-toast>

<!-- Modale di conferma eliminazione file -->
<app-conferma-eliminazione-file
    [(visible)]="showConfermaEliminazioneFile"
    [intervento]="intervento"
    [rendicontazione]="selectedRendicontazione"
    (eliminazioneConfermata)="eliminaFileRendicontazione()">
</app-conferma-eliminazione-file>

<!-- Modale lista file rendicontazione -->
<app-lista-file-rendicontazione
    [(visible)]="showListaFile"
    [intervento]="intervento"
    [rendicontazione]="selectedRendicontazione">
</app-lista-file-rendicontazione>

<!-- Modale conferma eliminazione rendicontazione -->
<p-dialog
  [(visible)]="showConfermaEliminazioneRendicontazione"
  [modal]="true"
  [closable]="false"
  [resizable]="false"
  [draggable]="false"
  [style]="{ width: '420px' }"
  styleClass="p-fluid conferma-eliminazione-rendicontazione-dialog"
>
  <ng-template pTemplate="header">
    <div class="confirm-header">
      <div class="confirm-header-left">
        <i class="pi pi-trash confirm-header-icon"></i>
        <span class="confirm-header-title">Conferma eliminazione rendicontazione</span>
      </div>
    </div>
  </ng-template>

  <div class="dialog-content confirm-dialog-content">
    <p class="confirm-main-text">
      Sei sicuro di voler eliminare questa rendicontazione?
    </p>
    <p class="confirm-sub-text">
      L'operazione non può essere annullata e verrà rimosso l'importo
      rendicontato associato a questo intervento.
    </p>
  </div>

  <ng-template pTemplate="footer">
    <div class="confirm-footer">
      <button
        pButton
        type="button"
        label="Annulla"
        class="p-button-text"
        (click)="showConfermaEliminazioneRendicontazione = false"
      ></button>
      <button
        pButton
        type="button"
        label="Elimina"
        class="p-button-danger"
        (click)="confermaEliminazioneRendicontazione()"
      ></button>
    </div>
  </ng-template>
</p-dialog>
